import { getSessionUserInformation } from "app/utils/utility.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  deleteWorkHistoryDetails,
  getDepletionDetails,
  getWorkHistoryDetails,
  insertLogs,
} from "../../homepurchase.service";
import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Menu } from "primereact/menu";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Button } from "primereact/button";
import AddWorkHistory from "./AddDepletion";
import { formatNumber } from "app/utils/utility.service";
import moment from "moment";
import { getSessionClientInformation } from "app/utils/utility.service";
import AddDepletion from "./AddDepletion";
import { formatNumberWithCommas } from "app/utils/utility.service";
import { getProjectedAssetValue } from "app/utils/utility.service";
const initialState = {
  name: "",
  value: "",
  amount: "",
  startDate: "",
  action: ""
};
const Depletion = () => {

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  let sessionValues =
      clientId && clientId !== "null"
        ? getSessionClientInformation()
        : getSessionUserInformation();
  const clientInfo = getSessionClientInformation();
  if (clientInfo) {
    sessionValues = clientInfo;
  }
  const userId =
  clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [values, setValues] = useState(initialState);

  const [title, setTitle] = useState("");
  const [addDepletionModal, setAddDepletionModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [depletionDetails, setDepletionDetails] = useState([]);
  const toast = useRef();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };

  useEffect(() => {
    setIsLoading(true);

    setValues({
      ...values,
      userId: userId,
    });
    fetchDepletionDetails();
  }, [addDepletionModal]);
  const renderAddDepletionModal = () => (
    <AddDepletion
      addDepletionModal={addDepletionModal}
      handleAddDepletionModal={handleAddDepletionModal}
      title={title}
      values={values}
      setValues={setValues}
    />
  );
  const handleAddDepletionModal = () => {
    if (!addDepletionModal) {
      const payload = {
        description: "Depletion",
      };
      insertLogs(payload);
    }

    setTitle("Add Depletion");

    setAddDepletionModal(!addDepletionModal);
  };
  const fetchDepletionDetails = async () => {
    let list = await getDepletionDetails(sessionValues.id);

    if (list) {
      setIsLoading(false);
      if (list) {
        list.map((li, index) => (li.srNo = index + 1));
      }
      setDepletionDetails(list);
    }
  };
  const indexBodyTemplate = (rowData, options) => {
    return options.rowIndex + 1; // Row index starts from 0, so add 1 to start from 1
  };
  const linkTemplate = (rowData, options) => {
    return (
      <span
        style={{
          textAlign: "center",
       //   whiteSpace: "pre-line",
          cursor: "pointer",
        }}
        onClick={() => setEditValues(rowData)}
      >
        {rowData.name}
      </span>
    );
  };
  const setEditValues = (rowData) => {
    setTitle("Edit Depletion Information");
    setValues({
      ...values,
      name: rowData.name,
      value: rowData.value,
      amount: rowData.value * (rowData.percentage / 100 || 0),
      startDate: rowData.startDate,
      action: rowData.action,
      percentage:rowData.percentage,
      id: rowData.id,
      accountCategoryId: rowData.id,
      purchaseDate: rowData.purchaseDate,
    });
    setAddDepletionModal(!addDepletionModal);
  };
  const priceTemplate = (rowData) => {
    const currentYear = Number(moment().format("YYYY"));
    const purchaseYear = rowData?.purchaseDate
          ? new Date(rowData?.purchaseDate).getFullYear()
          : currentYear;
    let assetVal = 0;
    if(purchaseYear !== currentYear) {
      assetVal = getProjectedAssetValue(rowData.value,rowData.annualGrowth,false, rowData.purchaseDate);
      
    } else {
      assetVal = rowData.value;
    }
    return <span>{"$ " + formatNumberWithCommas(assetVal)}</span>;
  };
  const amountTemplate = (rowData) => {
   
    return <span>{+ rowData.amount ? "$" + formatNumberWithCommas(rowData.amount) : ""}</span>;
  };
  const percentTemplate = (rowData) => {
    return <span>{rowData.percentage ? formatNumber(rowData.percentage) + " %":""}</span>;
  };
  const purdateTemplate = (rowData) => {
      let formattedDate = "";
      if (rowData.startDate) 
      formattedDate = moment(rowData.startDate).format('MM-DD-YYYY');
      return <span>{formattedDate}</span>;
    };
  const actionTemplate = (rowData, options) => {
    const menu = React.createRef();

    const handleEdit = () => {
      setEditValues(rowData);
    };

    /*const handleDelete = async () => {
      const details = await deleteWorkHistoryDetails(rowData.id);
      if (details) {
        showSuccess("Depletion deleted successfully");
        // insert settings value
        setIsLoading(false);
        setTimeout(() => {
          fetchDepletionDetails();
        }, 1000);
      } else {
        showError("Error");
      }
    };
    */

    const items = [
      { label: "Edit", command: handleEdit }
    ];

    return (
      <>
        <Menu model={items} popup ref={menu} />

        <i
          style={{ cursor: "pointer" }}
          className="pi pi-ellipsis-v"
          onClick={(event) => {
            menu.current.toggle(event);
          }}
        ></i>
      </>
    );
  };
  return (
    <div style={{ margin: "2rem" }}>
      <Toast ref={toast} className="ToastMessage" />
      <div className="grid mr-5">
        
        <div className="col-12" >
          <div className="bannerStyle " style={{textAlign:"start"}}>Depletion</div>
        </div>
       
      </div>
      <DataTable
        value={depletionDetails}
        className="propertyTable mt-3"
        responsiveLayout="scroll"
        emptyMessage="Please add depletion details."
        scrollHeight="600px"
        scrollDirection="both"
        rows={10}
        loading={isLoading}
        paginator={depletionDetails.length > 10}
        rowHover
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink   CurrentPageReport"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      >
        <Column header="ID" body={indexBodyTemplate}/>
        <Column
          sortable
          field="name"
          header="Asset"
          style={{ width: "25%" }}
          body={linkTemplate} 
        />
        <Column field="value" header="Current Value" body={priceTemplate} style={{ width: "15%" }} />
        <Column field="amount" header="Depletion Amount" body={amountTemplate}/>
        <Column field="startDate" header="Depletion Start Date" body={purdateTemplate}/>
        <Column field="percentage" header="% of Amount Depleted" body={percentTemplate}/>
        <Column field="action" header="Description" />
        <Column field="Actions" body={actionTemplate} header="Actions" />
      </DataTable>
      {addDepletionModal && renderAddDepletionModal()}
    </div>
  );
};

export default Depletion;
